@if (!loadingService.isActiveContext(LoadingContexts.loadingServiceNotifications)) {
  <div class="container">
    @let items = notifications();
    @if (items.length) {
      @for (notification of items; track notification) {
        <div class="alert alert-warning my-2">
          {{ notification.message }}
        </div>
      }
    }
  </div>
}
